export const getDateAsString = (date: Date): string => {
    return date.toISOString().slice(0, 10);
}

export const addHoursToDate = (date: Date, hours: number): Date => {
    date.setHours(date.getHours() + hours);
    return date;
}